/**
 * Global state management for PDP V4 using Alpine.js store
 * Manages product variant selection and provides centralized state for all PDP components
 */
(function() {
  function initPdpV4State() {
    Alpine.store('pdpV4State', {
      // Current product data
      product: {
        id: null,
        handle: null,
        title: null,
        price: null,
        compareAtPrice: null,
        vendor: null,
        type: null
      },

      // Selected variant data
      selectedVariant: {
        id: null,
        sku: null,
        title: null,
        price: null,
        compareAtPrice: null,
        available: null,
        inventoryQuantity: null,
        options: {},
        image: null,
        discontinued: false,
        unavailable: false
      },

      // Product status for form state
      productStatus: 'select_size',

      /**
       * Initialize state with product data
       * @param {Object} productData - Product data from Liquid
       */
      init(productData) {
        if (productData) {
          this.product = {
            id: productData.id,
            handle: productData.handle,
            title: productData.title,
            price: productData.price,
            compareAtPrice: productData.compareAtPrice,
            vendor: productData.vendor,
            type: productData.type
          };
        }
      },

      /**
       * Update selected variant
       * @param {Object} variantData - Variant data including id, price, availability, etc.
       */
      setSelectedVariant(variantData) {
        this.selectedVariant = {
          id: variantData.id || null,
          sku: variantData.sku || null,
          title: variantData.title || null,
          price: variantData.price || null,
          compareAtPrice: variantData.compareAtPrice || null,
          available: variantData.available !== undefined ? variantData.available : null,
          inventoryQuantity: variantData.inventoryQuantity || null,
          options: variantData.options || {},
          image: variantData.image || null,
          discontinued: variantData.discontinued || false,
          unavailable: variantData.unavailable || false
        };

        // Update product status based on variant state
        if (variantData.discontinued) {
          this.productStatus = 'discontinued';
        } else if (variantData.unavailable) {
          this.productStatus = 'unavailable';
        } else if (variantData.available) {
          this.productStatus = 'available';
        }
      },

      /**
       * Get current selected variant
       * @returns {Object} Current selected variant data
       */
      getSelectedVariant() {
        return this.selectedVariant;
      },

      /**
       * Get product data
       * @returns {Object} Product data
       */
      getProduct() {
        return this.product;
      },

      /**
       * Clear selected variant
       */
      clearSelectedVariant() {
        this.selectedVariant = {
          id: null,
          sku: null,
          title: null,
          price: null,
          compareAtPrice: null,
          available: null,
          inventoryQuantity: null,
          options: {},
          image: null,
          discontinued: false,
          unavailable: false
        };
        this.productStatus = 'select_size';
      },

      /**
       * Check if a variant is selected
       * @returns {Boolean} True if a variant is selected
       */
      hasSelectedVariant() {
        return this.selectedVariant.id !== null;
      },

      /**
       * Update product price (for testing scenarios)
       * @param {Number} price - New price
       * @param {Number} compareAtPrice - New compare at price
       */
      updateProductPrice(price, compareAtPrice = null) {
        this.product.price = price;
        if (compareAtPrice !== null) {
          this.product.compareAtPrice = compareAtPrice;
        }
      },

      /**
       * Set product status
       * @param {String} status - Product status (select_size, available, unavailable, discontinued)
       */
      setProductStatus(status) {
        this.productStatus = status;
      }
    });
  }

  // Handle Alpine loading scenarios
  document.addEventListener('alpine:init', initPdpV4State);

  // If Alpine is already loaded, initialize immediately
  if (window.Alpine) {
    initPdpV4State();
  }
})();